import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import api from "../../services/api";
export default function KnowledgeImage({ item }) {
  const [url, setUrl] = useState(""); const [failed, setFailed] = useState(false);
  useEffect(() => {
    let current = true, objectUrl; setUrl(""); setFailed(false);
    api.get(`/ai/items/${item.id}/image`, { responseType: "blob" }).then(({ data }) => {
      if (current) { objectUrl = URL.createObjectURL(data); setUrl(objectUrl); }
    }).catch(() => { if (current) setFailed(true); });
    return () => { current = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [item.id]);
  if (failed) return <Typography variant="caption">Imagem indisponível ou sem permissão de compartilhamento.</Typography>;
  return url ? <img src={url} alt={item.title} style={{ display: "block", maxWidth: "100%", maxHeight: 360, objectFit: "contain", marginTop: 12 }} /> : <Typography variant="caption">Carregando imagem…</Typography>;
}
